import { render, staticRenderFns } from "./file.vue?vue&type=template&id=f1fda72c&scoped=true&"
import script from "./file.vue?vue&type=script&lang=js&"
export * from "./file.vue?vue&type=script&lang=js&"
import style0 from "./file.vue?vue&type=style&index=0&id=f1fda72c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fda72c",
  null
  
)

export default component.exports